import define from "./define";
import {
  PlanPrice,
  PlanNonProfit,
  PlanProfessional,
  PlanTeam,
  PlanTeamPlus,
  PlanEnterprise,
} from "appConfig";

export const account = {
  // Registration
  complete_registration_head: "Complete Registration",
  complete_registration_desc:
    "Please fill in below information to finalize registration",
  head_account_type: "Account Type",
  account_type:
    "Are you a commercial company/organization, a nonprofit organization, or a private individual?",

  label_type: "Account Type",
  label_type_individual: "Individual",
  label_type_nonprofit: "Nonprofit Org.",
  label_type_company: "Company/Organization",

  head_company_info: "Company information",
  label_legalName: "Legal Name",
  label_country: "Country",
  label_vatNo: "VAT Number / TAX number",
  form_error_vatNo: "Not correct format for selected country",
  add_eu_vat_number: "Add an EU VAT number to avoid VAT charges",

  checking_vies_vat: "Checking EU VIES VAT number database...",
  checking_vies_vat_failed: "VAT number not found in EU VIES VAT databse",

  select_type_first: "Please select account type first",
  head_subscription: "Subscription",

  head_account_info: "Account Information",
  label_name: "Name",
  label_addressLine1: "Address",
  label_addressLine2: "Address (additional line)",
  label_addressCity: "City",
  label_addressRegion: "State or Region (if relevant)",
  label_addressPostalCode: "Postal Code",

  label_plan: "Plan",
  label_plan_free: define.free,
  label_plan_nonprofit:
    define.nonprofit + " - $" + PlanPrice[PlanNonProfit].yearly + "/year",
  label_plan_professional:
    define.professional +
    " - $" +
    PlanPrice[PlanProfessional].monthly +
    "/month ($" +
    PlanPrice[PlanProfessional].yearly +
    "/year)",
  label_plan_team:
    define.team +
    " - $" +
    PlanPrice[PlanTeam].monthly +
    "/month ($" +
    PlanPrice[PlanTeam].yearly +
    "/year)",
  label_plan_teamplus:
    define.teamplus +
    " - $" +
    PlanPrice[PlanTeamPlus].monthly +
    "/month ($" +
    PlanPrice[PlanTeamPlus].yearly +
    "/year)",
  label_plan_enterprise:
    define.enterprise +
    " - $" +
    PlanPrice[PlanEnterprise].monthly +
    "/month ($" +
    PlanPrice[PlanEnterprise].yearly +
    "/year)",

  label_receiptEmails: "Email address for receipts",

  label_paymentPeriod: "Payment Period",
  label_paidUntil: "Paid Until",
  label_paymentPeriod_monthly: "Monthly",
  label_paymentPeriod_yearly: "Yearly",
  label_termsAccepted: "I accept the terms",
  label_add_address_off: "Show address fields",
  label_add_address_on: "Hide address fields",

  head_account_terms: "Account Terms",
  account_terms: "To continue you must accept the terms of the service.",

  action_show_plans: "Show Plans",

  head_setup_account_success: "Account created!",
  setup_account_success:
    "Your account has been created. We have creating your first Onelink to your app. Start by adding your download links.",

  // PAYMENT GENERIC

  subscription_disclaimer: "Prices in USD excluding VAT. Subscriptions are auto-renewing.", 
  plans_hidden_over_limit: "Uneligible plans hidden (onelink count limit)",
  add_address_before_subscribing: "Please add your complete address before subscribing.",

  // LEGACY ACCOUNT
  head_legacy_transfer: "Transfer existing onelinks",
  legacy_transfer:
    'We have found existing onelinks registered to your email address.\n\nDo you wish to transfer those to this new account?\nThis can also be done later from "My Account".',
  legacy_transfer_unverified:
    'Do you have existing onelinks you wish to transfer to this new account?\n\nUntil your email address is verified, we cannot proceed with any transfers.\nPlease verify your email address (look in your inbox) and reload this page.\n\nThis can also be done later from "My Account".',
  label_transferLegacy: "Transfer existing onelinks",

  // WELCOME BACK

  head_welcome_back: "🎉 Welcome Back 🎉",
  welcome_back:
    'We have launched a new platform since you were last here.\n\nYou need to create a new account and supply us with some more information.\n\nAll your existing onelinks are still working, just make sure you select to "Transfer existing onelinks" further down this page.\n\nWe hope that you will support our service by signing up for a paid plan, but you also have the choice to continue using Onelink.to using the Free plan, and upgrade when/if you grow out of it.',

  // DELETE ACCOUNT (COMPLETE REGISTRATION)
  cancel_registration: "Cancel registration",
  button_delete_account: "Delete account",
  delete_account_head: "Changed your mind?",
  delete_account_info: "If you changed your mind, then you can go ahead and delete your account by clicking on the button below. All you personal information will be deleted. You can create a new account at any time."


};
